import React from "react";
import { Link } from "react-router-dom";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Collapse,
  NavItem,
  NavLink
} from "shards-react";
import { connect } from "react-redux"
import { setLogout } from "../../../../actions/userActions";
import { logout } from "../../../../services"

class UserActions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
    };

    this.toggleUserActions = this.toggleUserActions.bind(this);
  }

  toggleUserActions() {
    this.setState({
      visible: !this.state.visible
    });
  }

  render() {
    return (
      <NavItem tag={Dropdown} caret toggle={this.toggleUserActions}>
        <DropdownToggle caret tag={NavLink} className="text-nowrap px-3">
          <img
            className="user-avatar rounded-circle mr-2"
            src={this.props.avatar ? this.props.avatar : 'https://media.licdn.com/dms/image/C560BAQGEnInsRv1uMw/company-logo_200_200/0?e=2159024400&v=beta&t=3azC9XIkxEEhZvsexUklHHVsH_v0o1Njp_UlV6esehw'}
            alt="User Avatar"
            style={{ objectFit: 'cover', height: '2.5rem' }}
          />{" "}
          <span className="d-none d-md-inline-block">{this.props.username}</span>
        </DropdownToggle>
        <Collapse tag={DropdownMenu} right small open={this.state.visible}>
          <DropdownItem tag={Link} to="/login" className="text-danger" onClick={() => {
            logout();
            setLogout(true);
          }
          }>
            <i className="material-icons text-danger">&#xE879;</i> Logout
          </DropdownItem>
        </Collapse>
      </NavItem>
    );
  }
}

const mapStateToProps = state => ({
  username: state.user.username,
  avatar: state.user.avatar
})

const bindActions = dispatch => ({
  setLogout: logout => dispatch(setLogout(logout))
})

export default connect(mapStateToProps, bindActions)(UserActions);
